export const getCacheKey = ({ keyId, seedId }) => {
    const components = [
        seedId,
        keyId.keyType,
        keyId.derivationAlgorithm,
        keyId.derivationPath,
        keyId.assetName,
    ];
    return components
        .filter(Boolean)
        .map((component) => encodeURIComponent(component))
        .join('/');
};
